import React from "react";

export default function Unauthorized() {
  console.log('[Unauthorized] ❌ Rendering Unauthorized page');

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-50">
      <h1 className="text-3xl font-bold text-red-600 mb-4">Geen toegang</h1>
      <p className="text-gray-700 mb-6">
        Je bent aangemeld, maar hebt geen toegang tot deze pagina.
      </p>
    </div>
  );
}
